import { apiClient } from '@v2/lib';
import type { Role } from '@v2/types';

/**
 * Roles Service
 *
 * Domain: User role management
 * Base path: /roles
 *
 * Queries:
 *   - getRoles() → GET /roles
 */

export const rolesService = {
  getRoles: async (): Promise<Role[]> => {
    const response = await apiClient().get<Role[]>('roles');
    return response.data;
  },
};
